<template>
    <div class="x-image-upload">
        <el-upload
            class="avatar-uploader"
            :action="config?.action"
            :show-file-list="false"
            :headers="{'Authorization': 'Bearer ' + tokenStore.token}"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
        >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
        </el-upload>
    </div>
</template>
<script setup>
import { getCurrentInstance, ref, watch } from 'vue';
import { UploadFilled, CircleCheck, Close, Document } from '@element-plus/icons-vue';
import { ElMessage, genFileId } from 'element-plus'
import axios from 'axios';
import { useTokenStore } from '../../store/TokenStore';
import { getSign } from '../../remoteservice/RemoteService';

const inst = getCurrentInstance();
const tokenStore = useTokenStore();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})

defineEmits({
    'update:modelValue': null,
    'update:data': null,
})

const imageUrl = ref('')
watch(()=>props.modelValue, (value)=> {
    imageUrl.value = props.config.download + '/' + btoa(value);
}, {immediate:true})

const handleAvatarSuccess = (res, file) => {
    inst.emit('update:modelValue', res.data.resourceUri);
}

const beforeAvatarUpload = (rawFile) => {
    // if (rawFile.type != 'image/jpeg' || rawFile.type != 'image/jpg' || rawFile.type != 'image/png' || rawFile.type != 'image/bmp') {
    //     console.log(rawFile.type)
    //     ElMessage.error('请选择图片格式的文件')
    //     return false
    // } else 
    if (rawFile.size / 1024 / 1024 > 200) {
        ElMessage.error('图片大小不能超过200MB')
        return false
    }
    return true
}
</script>
<style scoped>
.x-image-upload {
    width: 100%;
}
.x-image-upload .avatar-uploader .avatar {
    width: 300px;
    height: 200px;
    display: block;
}
.x-image-upload .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.x-image-upload .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.x-image-upload .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
}
</style>
